<script>
import {
  cashMetaFields,
  bankPaymentMetaFields,
  weiverMetaFields,mpesaMetaFields,
} from "./metaFields";
import { Validator } from "@/plugins/validator";
export default {
  name: "ReceiptInvoiceForm",

  data() {
    return {
      active: 0,
      activeTab: 0,
      activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
      inActiveClass: `bg-gray-300 border-l border-r border-t`,
      stkinitiated: 0,
      stkresponse: '',
      stkresponsemessage: 'Successfully Initiated On Phone',
        patient: {},
      billItems: [],
      loaders:{},
      lcoa:[],
      showPatientDetails:false,
      cashSale: {
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        paymentModeID: 0,
        accountID: 0,
        cashRef: ``,
        totalCashAmount: 0,
      },
      mppay: {
        patientID: this.$route.params.patientID,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        amount: 0,
        PatientName: ``,
        phonenumber:0, 
      },
      bankPayment: {
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        paymentModeID: 0,
        accountID: 0,
        bankPayDate: window.moment().format(`YYYY-MM-DD`),
        totalBankAmount: 0,
      },
      depositAllocation: {
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        allocations: {},
      },
       mpesaAllocation: {
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        allocations: {},
        
      },
      insuranceInvoice: {
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        insurance: {
          benefitPackageID: 0,
          schemeId: 0,
        },
      },
      initiateWeiver: {
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        weiverAmount: 0,
      },
      showConfirmCashSale: false,
      showConfirmBankPayment: false,
      showConfirmDepAllocation: false,
      showConfirmMpesaAllocation: false,
      showConfirmInsuranceInvoice: false,
      showConfirmInitiateWeiver: false,
      checkAllBillItems: true,
      showPatientBill: false,
      cashErrors: [],
      bankErrors: [],
      weiverErrors: [],
      mpesaErrors:[],
      deposits: [],
      insurances: [],
      cashCOAs: [],
      cashPModes: [],
      bankCOAs: [],
      bankPModes: [],
      benefitPackages: [],
      insuranceSchemes: [],
      patientVisits: [],
      mpesafilter:'',
      mpesapayments:[],
    };
  },

  computed: {
    totalReceive() {
      if (!this.billItems.length) return 0;

      const checkedBills = this.billItems.filter(
        (billItem) => billItem.checked
      );

      return checkedBills.length
        ? checkedBills
            .map((billItem) => parseFloat(billItem.allocatedAmount))
            .reduce((sum, amt) => sum + amt)
        : 0;
    },

    totalBalance() {
      if (!this.billItems.length) return 0;

      const checkedBills = this.billItems.filter(
        (billItem) => billItem.checked
      );

      return checkedBills.length
        ? checkedBills
            .map((billItem) => parseFloat(billItem.balance))
            .reduce((sum, amt) => sum + amt)
        : 0;
    },

    checkedBillItems() {
      if (!this.billItems.length) return [];

      const checkedBills = this.billItems.filter(
        (billItem) => billItem.checked && !billItem.pendingWeiver
      );

      return checkedBills.length
        ? checkedBills.map((billItem) => {
            return {
              invoiceDetailID: billItem.invoiceDetailID,
              itemID: billItem.itemID,
              itemName: billItem.itemName,
              billNo: billItem.bill_No,
              billAmount: billItem.balance,
              allocatedAmount: billItem.allocatedAmount,
              description: billItem.itemName,
              cashItem: billItem.cashItem,
            };
          })
        : [];
    },

    unallocatedDeposits() {
      if (!this.deposits.length) return 0;

      return this.deposits
        .map((dep) => parseFloat(dep.unAllocatedAmount))
        .reduce((amt, sum) => amt + sum);
    },

    allocatedDeposits() {
      if (!this.depositAllocation.allocations.id) return [];

      return [
        {
          ...this.depositAllocation.allocations,
        },
      ];
    }, allocatedmpesaPayments() {
      if (!this.mpesaAllocation.allocations.id) return [];

      return [
        {
          ...this.mpesaAllocation.allocations,
        },
      ];
    },

    totalDepositAmount() {
      if (!this.depositAllocation.allocations.id) return 0;

      return this.depositAllocation.allocations.amount;
    }, 
    totalmpesaAmount() {
      if (!this.mpesaAllocation.allocations.id) return 0;

      return this.mpesaAllocation.allocations.amount;
    },

    insuranceDetails() {
      return this.insuranceInvoice.insurance.organizationID
        ? [
            {
              organizationID: this.insuranceInvoice.insurance.organizationID,
              benefitPackageID: this.insuranceInvoice.insurance
                .benefitPackageID,
              benefitPackage: this.insuranceInvoice.insurance.benefitPackage,
              schemeId: this.insuranceInvoice.insurance.schemeId,
              scheme: this.insuranceInvoice.insurance.scheme,
              amount: this.totalReceive,
            },
          ]
        : [];
    },
  },

  watch: {
    "insuranceInvoice.insurance.benefitPackageID"() {
      if (
        !this.insuranceInvoice.insurance.benefitPackageID ||
        !this.benefitPackages.length
      )
        return;

      this.benefitPackages.forEach((packag) => {
        if (
          packag.packageId == this.insuranceInvoice.insurance.benefitPackageID
        ) {
          this.insuranceInvoice.insurance.benefitPackage = packag.packageName;
        }
      });
    },

    "insuranceInvoice.insurance.schemeId"() {
      if (
        !this.insuranceInvoice.insurance.schemeId ||
        !this.insuranceSchemes.length
      )
        return;

      this.insuranceSchemes.forEach((scheme) => {
        if (scheme.schemeId == this.insuranceInvoice.insurance.schemeId) {
          this.insuranceInvoice.insurance.scheme = scheme.schemeName;
        }
      });
    },

    checkAllBillItems() {
      if (!this.checkAllBillItems) {
        this.billItems.forEach((billItem) => {
          if (!billItem.pendingWeiver) {
            billItem.checked = false;
            billItem.allocatedAmount = 0;
          }
        });

        return;
      }

      this.billItems.forEach((billItem) => {
        if (!billItem.pendingWeiver) {
          billItem.checked = true;
          billItem.allocatedAmount = billItem.balance;
        }
      });
    },
  },

  components: {
    "cash-sale-form": () => import("./tabs/CashSale.vue"),
    "bank-deposit-form": () => import("./tabs/BankReceipt.vue"),
    "allocate-deposit-form": () => import("./tabs/AllocateDeposit.vue"),
    "allocate-mpesa-form": () => import("./tabs/AllocateMpesaPayments.vue"),
    "waiver-form": () => import("./tabs/Waiver.vue"),
    "insurance-invoice-form": () => import("./tabs/InsuranceInvoice.vue"),
    "confirm-cash-sale": () => import("./modals/ConfirmCashSale.vue"),
    "confirm-bank-payment": () => import("./modals/ConfirmBankPayment.vue"),
    "confirm-deposit-allocation": () =>
      import("./modals/ConfirmDepositAllocation.vue"),
      "confirm-mpesa-allocation": () =>
      import("./modals/ConfirmMpesaAllocation.vue"),
    "confirm-insurance-invoice": () =>
      import("./modals/ConfrmInsuranceInvoice.vue"),
    "confirm-initiate-weiver": () =>
      import("./modals/ConfirmInitiateWeiver.vue"),
    "combined-payment-form": () => import("./main-tabs/Combined.vue"),
    "discharge-bill-details": () =>
      import("@/components/commons/billing/PerVisitPatientBillBreakdown.vue"),
    "allow-for-service-form": () => import("./modals/PayLater.vue"),
    
    "patient-details-modal": () => import('@/components/commons/patient/ViewPatientDetails.vue'),
  },

  mounted() {
    this.$root.loading = true;
    Promise.allSettled([
      this.fetchPatient(),
      this.ReceiptandInvoiceDetails(),
   //   this.fetchPendingPostedBills(),
      //this.fetchDeposits(),
     // this.fetchInsurances(),
      //this.fetchCashCOAs(),
     // this.fetchCashPModes(),
     // this.fetchBankCOAs(),
      //this.fetchBankPModes(),
     // this.fetchBenefitPackages(),
     // this.fetchInsuranceSchemes(),
    ])
      .then(() => {
        this.$root.loading = false;
      })
      .catch(() => {
        this.$root.loading = false;
      });
  },

  methods: {
    fetchPatient() {
      let queryString = `?PatientID=${this.$route.params.patientID}`;

      return this.$http
        .get(`PatientRegistration/GetSpecificPatient${queryString}`)
        .then(({ data }) => {
          this.patient = data.length
            ? { ...data[0], patientID: data[0].patienT_ID,patientname:data[0].names.replace(/\s+/g, '_') }
            : {};
        })
        .catch(() => {});
    },
    
    ReceiptandInvoiceDetails() {
      const queryString = `?PatientId=${this.$route.params.patientID}`;

      return this.$http
        .get(`Accounts/ReceiptandInvoiceDetails${queryString}`)
        .then((response) => {
         // this.loaders = response.data;
          

          this.cashPModes = response.data.paymentModes.filter(g=>g.typeID===2);
           //this.cashPModes = response.data.paymentModes;
            this.cashCOAs = response.data.coaDetails.filter(g=>g.coaName === "Cash Sales");
          this.bankCOAs = response.data.coaDetails.filter(g=>g.coaCategoryID===4);
           this.bankPModes = response.data.paymentModes.filter(g=>g.typeID===1);
          // this.bankCOAs = this.loaders.paymentModes.filter(g=>g.typeID=2);
          // this.insuranceSchemes =  this.loaders.insuranceSchemes;
          // this.benefitPackages =  this.loaders.benefitPackages;
          this.billItems = response.data.postedBillDetails.map((billItem) => {
            return {
              ...billItem,
              allocatedAmount: billItem.pendingWeiver ? 0 : billItem.balance,
              checked: billItem.pendingWeiver ? false : true,
              allow: false,
            };
          });
            this.insurances = response.data.patientSelectedOrgs.map((ins) => {
            return {
              ...ins,
              viewDetails: false,
              selected: false,
              schemeId: 0,
              benefitPackageID: 0,
            };
          });
           this.deposits=response.data.pendingDepositReceiptDetails.map((dep) => {
            return {
              ...dep,
              unAllocatedAmount: parseFloat(dep.unAllocatedAmount),
            };
          }); 
         
        })
        .catch(() => {});
    },
    fetchPendingPostedBills() {
      const queryString = `?PatientId=${this.$route.params.patientID}`;

      return this.$http
        .get(`Accounts/GetPatientsPendingpostedBills${queryString}`)
        .then(({ data }) => {
          this.billItems = data.map((billItem) => {
            return {
              ...billItem,
              allocatedAmount: billItem.pendingWeiver ? 0 : billItem.balance,
              checked: billItem.pendingWeiver ? false : true,
              allow: false,
            };
          });
        })
        .catch(() => {});
    },

    fetchDeposits() {
      const queryString = `?PatientId=${this.$route.params.patientID}`;

      return this.$http
        .get(`Accounts/GetPendingPatientDeposits${queryString}`)
        .then(({ data }) => {
          this.deposits = data.map((dep) => {
            return {
              ...dep,
              unAllocatedAmount: parseFloat(dep.unAllocatedAmount),
            };
          });
        })
        .catch(() => {});
    },

    fetchInsurances() {
      const queryString = `?PatientId=${this.$route.params.patientID}`;

      return this.$http
        .get(`Accounts/GetPatientSelectedOrgs${queryString}`)
        .then(({ data }) => {
          this.insurances = data.map((ins) => {
            return {
              ...ins,
              viewDetails: false,
              selected: false,
              schemeId: 0,
              benefitPackageID: 0,
            };
          });
        })
        .catch(() => {});
    },

    fetchCashCOAs() {
      return this.$http
        .get(`Accounts/GetCashCOA`)
        .then((response) => {
          this.cashCOAs = response.data;
        })
        .catch(() => {});
    },

    fetchCashPModes() {
      return this.$http
        .get(`Accounts/GetCashPaymentModes`)
        .then((response) => {
          this.cashPModes = response.data;
        })
        .catch(() => {});
    },

    fetchBankCOAs() {
      return this.$http
        .get(`Accounts/GetBankCOA`)
        .then((response) => {
          this.bankCOAs = response.data;
        })
        .catch(() => {});
    },

    fetchBankPModes() {
      return this.$http
        .get(`Accounts/GetBankPaymentModes`)
        .then(({ data }) => {
          this.bankPModes = data; 
        })
        .catch(() => {});
    },

    fetchBenefitPackages() {
      return this.$http
        .get(`MasterData/GetInsuranceBenefitPackages`)
        .then(({ data }) => {
          this.benefitPackages = data;
        })
        .catch(() => {});
    },

    fetchInsuranceSchemes() {
      return this.$http
        .get(`MasterData/GetInsuranceSchemes`)
        .then((response) => {
          this.insuranceSchemes = response.data;
        })
        .catch(() => {});
    },

    fetchPatientVisits() {
      if (!this.patient.patienT_ID && !this.patient.visitNo)
        return Promise.reject();

      this.$root.loading = true;
      let url = `Visits/GetPatientVisits`;
      url += `?CustomerID=${this.patient.patienT_ID}`;

      return this.$http
        .get(url)
        .then(({ data }) => {
          this.patientVisits = data;
          this.showPatientBill = true;
          this.$root.loading = false;
        })
        .catch(() => {
          this.$root.loading = false;
        });
    },
    initiatempesastk(phonenumber,amount,accountno) {
      //var amount=0;
      // var phoneNumber=mpay.phonenum;
      // var accountNumber=this.patient.names;
      this.mppay.phonenumber=phonenumber,
      this.mppay.amount=amount,

      new Validator(this.mppay, mpesaMetaFields)
        .validate()
        .then(() => {
          this.mpesaErrors = [];
          var description='Patient_Payment';
          
          let url = `PayLoader/StkPush`;
                url += `?PhoneNumber=${phonenumber}`;
                url += `&AccountNumber=${accountno}`;
                url += `&Amount=${amount}`;
                 url += `&Description=${description}`;
    
                return this.$http.get(url).then(response => {
                  this.stkresponse=response.data;
                    this.stkinitiated=1;
                    this.mpesafilter=accountno;
                   
                }).catch(() => {});
        })
        .catch((errors) => {
          this.mpesaErrors = errors;
        });
        
        
        },
        filtermpesapayments() {

          if (!this.mpesafilter) {
            this.mpesafilter=this.patient.names;
          }
            let url = `Accounts/GetSpecificIPNPayments`;
            url += `?StkInitiated=${this.stkinitiated }&`;
            url += `Allocated=0&SearchText=${this.mpesafilter}`;
            
            return this.$http.get(url).then(response => {
                this.mpesapayments = response.data;
               
            }).catch(() => {});
        },
    resetCashSale() {
      this.cashSale = {
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        paymentModeID: 0,
        accountID: 0,
        cashRef: ``,
        totalCashAmount: this.totalReceive,
      };
    },

    resetbankPayment() {
      this.bankPayment = {
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        paymentModeID: 0,
        accountID: 0,
        bankPayDate: window.moment().format(`YYYY-MM-DD`),
        totalBankAmount: this.totalReceive,
      };
    },

    resetInitiateWeiver() {
      this.initiateWeiver = {
        patientID: this.$route.params.patientID,
        visitNo: this.$route.params.visitNO,
        txnDate: window.moment().format(`YYYY-MM-DD`),
        userName: this.$root.username,
        weiverAmount: this.totalReceive,
      };
    },

    saveCashSale() {
      new Validator(this.cashSale, cashMetaFields)
        .validate()
        .then(() => {
          this.cashErrors = [];
          this.showConfirmCashSale = true;
        })
        .catch((errors) => {
          this.cashErrors = errors;
        });
    },

    saveBankPayment() {
      new Validator(this.bankPayment, bankPaymentMetaFields)
        .validate()
        .then(() => {
          this.bankErrors = [];
          this.showConfirmBankPayment = true;
        })
        .catch((errors) => {
          this.bankErrors = errors;
        });
    },

    saveDepositAllocation() {
      new Validator({ dep: this.allocatedDeposits }, [
        { name: `Deposits allocated`, field: `dep`, check: `ArrayHasItems` },
      ])
        .validate()
        .then(() => {
          this.showConfirmDepAllocation = true;
        })
        .catch((errors) => {
          window.Swal.fire({ type: `error`, text: errors[0].message });
        });
    },saveMpesaAllocation() {
      new Validator({ dep: this.allocatedmpesaPayments }, [
        { name: `Mpesa  allocated`, field: `dep`, check: `ArrayHasItems` },
      ])
        .validate()
        .then(() => {
          this.showConfirmMpesaAllocation = true;
        })
        .catch((errors) => {
          window.Swal.fire({ type: `error`, text: errors[0].message });
        });
       
    },

    saveInsuranceInvoice() {
      new Validator(
        { insurances: this.insuranceDetails, memo: this.insuranceInvoice.memo },
        [
          { name: `Insurances`, field: `insurances`, check: `ArrayHasItems` },
          { name: `Memo`, field: `memo`, check: `required` },
        ]
      )
        .validate()
        .then(() => {
          this.showConfirmInsuranceInvoice = true;
        })
        .catch((errors) => {
          window.Swal.fire({
            type: `error`,
            text: errors.map((err) => err.message).join(" "),
          });
        });
    },

    saveWeiver() {
      new Validator(this.initiateWeiver, weiverMetaFields)
        .validate()
        .then(() => {
          this.weiverErrors = [];
          this.showConfirmInitiateWeiver = true;
        })
        .catch((errors) => {
          this.weiverErrors = errors;
        });
    },

    printReceipt(receiptNo) {
      let url = `/${this.patient.patienT_ID}/${receiptNo}`;

      window.open(
        `/billing/receipt-invoice/print${url}`,
        "_blank",
        `ReceiptCash`,
      );
    },

    printInsuranceInvoice(invoiceNo) {
      let url = `/${this.patient.patienT_ID}/${invoiceNo}`;

      window.open(
        `/billing/receipt-invoice-insurance/print${url}`,
        "_blank",
        `InvoiceInsurance`,
      );
    },

    printDepositReceipt(receiptNo) {
      let url = `/billing/receipt-deposit/print-single`;
      url += `?PatientID=${this.patient.patienT_ID}&ReceiptNo=${receiptNo}`;

      window.open(
        url,
        "_blank",
        `ReceiptDepositReceipt`,
      );
    },

    printAllowServiceSlip() {
      let url = `/billing/allowed-services/print?patientId=${this.patient.patienT_ID}`;

      window.open(
        url,
        "_blank",
        `ReceiptDepositReceipt`,
      );
    },
  },
};
</script>
<template>
  <tail-base-layout>
    <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <div class="flex md:flex-row sm:flex-col">
            <div class="flex-1">
            <h5 class="font-medium text-sm">Receipt/ Invoice</h5> 
            </div>
            <div class="flex-1">
              <router-link
                class="btn-sm text-xs btn-primary rounded"
                :to="{
                  name: patient.patienT_ID ? `billing.bill-patient.create` : ``,
                  params: {
                    patientID: patient.patienT_ID,
                    visitNO: patient.visitNo,
                  },
                }"
              >
                <i class="fa fa-hand-holding-usd"></i> Bill Patient
              </router-link>
            </div>
            <div class="flex-1"  v-if="$root.checkAuth('ReceivecashOrmpesa')">
              <router-link
                class="btn-sm text-xs font-semibold text-white bg-indigo-600 text-xs rounded whitespace-no-wrap"
                :to="{
                  name: patient.patienT_ID
                    ? `billing.receive-deposits.index`
                    : ``,
                  params: {
                    patientID: patient.patienT_ID,
                    visitNO: patient.visitNo,
                  },
                }"
              >
                <i class="fa fa-hand-holding-usd"></i> Receive Deposit
              </router-link>
            </div>
            <div class="flex-1">
              <button
                @click.prevent="fetchPatientVisits"
                class="btn-sm btn-warning text-xs rounded"
              >
                <i class="fa fa-list"></i> Interim Bill
              </button>
              <discharge-bill-details
                :patient="patient"
                :showModal="showPatientBill"
                :visits="patientVisits"
                :routeParams="{
                  patientID: patient.patienT_ID,
                  visitNO: patient.visitNo,
                }"
                @closeModal="showPatientBill = false"
              />
            </div>
            <div class="flex-1">
                        <button 
                            class="btn-sm text-xs btn-info rounded-md" 
                            @click.prevent="!patient.patienT_ID ? `` : showPatientDetails=true">
                                <i class="fa fa-archive"></i> View Patient Details
                          </button>
                          <patient-details-modal 
                            :patient="patient" 
                            :showModal="showPatientDetails" 
                            @closeModal="showPatientDetails=false"
                          />
                      </div>
          </div>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap rounded border-2 border-green-500 sm:my-1">
            <div class="w-full bg-green-500 p-tiny">
              <h5 class="font-bold text-white text-sm">Patient Details</h5>
            </div>
            <div class="w-full flex flex-wrap max-h-8 overflow-auto" style="height:3rem">
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Name: 
                                        <span class="text-blue-700">{{ patient.names }}</span></h5>
                              </div>
                              <div class="md:w-1/12 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">MRN No: 
                                        <span class="text-blue-700">{{ patient.patienT_ID }}</span></h5>
                              </div> <div class="md:w-1/12 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">ID NO: 
                                        <span class="text-blue-700">{{ patient.nationalid }}</span></h5>
                              </div>
                              <div class="md:w-1/12 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">IPFile NO: 
                                        <span class="text-blue-700">{{ patient.ipfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/12 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">OPFile NO: 
                                        <span class="text-blue-700">{{ patient.opfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/6 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Status: 
                                        <span class="text-blue-700">
                                            {{ 
                                                patient.iS_IN_PATIENT == `True` ? `Inpatient` : `Outpatient` 
                                            }}
                                        </span></h5>
                              </div>
                              <div class="md:flex-1 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">P Mode: 
                                        <span class="text-blue-700">
                                            {{ patient.pMode }}
                                        </span></h5>
                              </div>
                          </div>
          </div>
          <div
            class="flex md:flex-row sm:flex-col content-start overflow-auto"
            style="height:65vh"
          >
            <div
              class="md:w-3/5 sm:w-full flex flex-wrap border-r-2 border-b-2 border-l-2 
                        border-blue-500 rounded-md"
            >
              <div class="w-full overflow-auto">
                <table class="table">
                  <thead class="bg-blue-500 text-xs text-white">
                    <tr class="w-full flex">
                      <th class="p-tiny w-1/12">Code</th>
                      <!-- <th class="p-tiny w-1/12">Bill No</th> -->
                      <th class="p-tiny flex-1">Date</th>
                      <th class="p-tiny flex-1 break-words">Item</th>
                      <th class="p-tiny flex-1 break-words">Description</th>
                      <th class="p-tiny flex-1 break-words">Consultant</th>
                      <th class="p-tiny flex-1">Qty</th>
                      <th class="p-tiny flex-1">Amt</th>
                      <th class="p-tiny flex-1">Balance</th>
                      <th class="p-tiny flex-1">Receipt</th>
                      <th
                        v-if="$root.checkAuth(`AllowPayLater`)"
                        class="p-tiny flex-1"
                      >
                        Allow For Service
                      </th>
                      <th class="p-tiny flex-1">
                        Select
                        <input type="checkbox" v-model="checkAllBillItems" />
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    class="text-xs bg-gray-100 flex flex-col items-center overflow-auto"
                    style="max-height:26rem; min-height:15rem;"
                  >
                    <tr
                      v-for="(billItem, idx) in billItems"
                      :key="idx"
                      class="w-full flex border-b"
                      :class="{
                        'bg-orange-200': billItem.pendingWeiver,
                        'bg-yellow-300': $root.formatFloat(billItem.cashItem),
                      }"
                    >
                      <td class="p-tiny w-1/12">
                        {{ billItem.invoiceDetailID }}
                      </td>
                      <!-- <td class="p-tiny w-1/12">{{ billItem.bill_No }}</td> -->
                      <td class="p-tiny flex-1">
                        {{ billItem.date | dateFormat }}
                      </td>
                      <td class="p-tiny flex-1 break-words">
                        {{ billItem.itemName }}
                        <span class="font-bold">{{
                          billItem.pendingWeiver ? `- (Waivered)` : ``
                        }}</span>
                      </td> <td class="p-tiny flex-1 break-words">
                        {{  billItem.memo ?  billItem.memo : `` }} 
                       
                      </td>
                       <td class="p-tiny flex-1 break-words">
                        {{ billItem.consultant }}
                        
                      </td>
                      <td class="p-tiny flex-1">{{ billItem.quantity }}</td> 
                      <td class="p-tiny flex-1">
                        {{ billItem.amount | numberFormat }}
                      </td>
                      <td class="p-tiny flex-1">
                        {{ billItem.balance | numberFormat }}
                      </td>
                      <td class="p-tiny flex-1">
                        <input
                          type="number"
                          v-model.number="billItem.allocatedAmount"
                          :disabled="billItem.pendingWeiver ? true : false"
                          class="input-control input-sm text-xs text-right"
                          :class="billItem.pendingWeiver ? `disabled` : ``"
                        />
                      </td>
                      <td
                        v-if="$root.checkAuth(`AllowPayLater`)"
                        class="p-tiny flex-1"
                      >
                        <button 
                            @click.prevent="billItem.allow = true"
                            class="btn-sm text-xs rounded"
                            :class="billItem.allowForService ? `btn-info` : `btn-warning`"
                            >
                          <i :class="!billItem.allowForService ? `fa fa-check` : `fa fa-undo`"></i>
                          {{ billItem.allowForService ? `Revert Allow` : `Allow Service`}} 
                        </button>
                        <span class="text-xs font-medium capitalize">{{
                          billItem.allowForServiceUser
                        }}</span>
                        <allow-for-service-form 
                            :showModal="billItem.allow"
                            :item="billItem"
                            @refresh="fetchPendingPostedBills"
                            @closeModal="billItem.allow = false"
                        />
                      </td>
                      <td class="p-tiny flex-1">
                        <input
                          type="checkbox"
                          @change="
                            () => {
                              if (!billItem.checked) {
                                billItem.allocatedAmount = 0;
                                return;
                              }
                              billItem.allocatedAmount = billItem.balance;
                            }
                          "
                          :disabled="billItem.pendingWeiver ? true : false"
                          v-model="billItem.checked"
                          class=" ml-3 px-4"
                        />
                      </td>
                    </tr>
                  </tbody>
                  <tfoot
                    v-if="$root.checkAuth(`AllowPayLater`)"
                    class="bg-gray-500"
                  >
                    <tr class="w-full flex">
                      <th colspan="9" class="p-tiny flex-1"></th>
                      <th class="p-tiny w-1/2 text-right">
                        <button
                          @click.prevent="printAllowServiceSlip"
                          class="btn-primary btn-sm text-xs rounded mr-3"
                        >
                          <i class="fa fa-print"></i> Print Allow Service Slip
                        </button>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="md:w-2/5 sm:w-full flex flex-col px-1">
              <div
                class="w-full flex flex-col bg-blue-600 mb-1 rounded text-white whitespace-no-wrap uppercase"
              >
                <div class="flex-1 p-1">
                  <h5 class="font-bold text-sm">
                    Balance: {{ totalBalance | numberFormat }}
                  </h5>
                </div>
                <div class="flex-1 p-1">
                  <h5 class="font-bold text-sm uppercase">Pending waiver:</h5>
                </div>
                <div class="flex-1 p-1">
                  <h5 class="font-bold text-sm">
                    Un-allocated deposit:
                    {{ unallocatedDeposits | numberFormat }}
                  </h5>
                </div>
              </div>
              <div
                class="w-full flex flex-wrap rounded-md border-2 border-blue-800 p-px"
              >
                <ul class="w-full flex border-b-2 border-gray-400">
                  <li class="-mb-px mr-1">
                    <a
                      href="javascript:void(0)"
                      @click.prevent="activeTab = 0"
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                      :class="activeTab === 0 ? activeClass : inActiveClass"
                      >Receive Payment/ Invoice</a
                    >
                  </li>
                  <li class="-mb-px mr-1">
                    <a
                      href="javascript:void(0)"
                      @click.prevent="activeTab = 1"
                      class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                      :class="activeTab === 1 ? activeClass : inActiveClass"
                      >Combined Payments</a
                    >
                  </li>
                </ul>
                <div class="w-full" v-if="activeTab === 1">
                  <combined-payment-form
                    :cashCOAs="cashCOAs"
                    :cashPModes="cashPModes"
                    :bankCOAs="bankCOAs"
                    :bankPModes="bankPModes"
                    :totalBalance="totalBalance"
                    :totalReceive="totalReceive"
                    :checkedBillItems="checkedBillItems"
                    :patient="patient"
                    :insurances="insurances"
                    :deposits="deposits"
                    :benefitPackages="benefitPackages"
                    :insuranceSchemes="insuranceSchemes"
                    @refresh="fetchPendingPostedBills"
                  />
                </div>
                <div class="w-full flex flex-wrap" v-if="activeTab === 0">
                  <div class="w-full p-tiny">
                    <label for="grid-type" class="label-control">Type:</label>
                    <tail-select>
                      <template v-slot:field>
                        <select
                          v-model="active"
                          id="grid-type"
                          class="input-control input-sm text-xs"
                        >
                        <!-- <option :value="5" v-if="$root.checkAuth('Receivecash')">MPESA Payment </option> -->
                        <option :value="0" v-if="$root.checkAuth('Receivempesa')">Cash Sale</option>
                          <option :value="1" v-if="$root.checkAuth('Receivebank')">Bank Receipt</option>
                          <option :value="2" v-if="$root.checkAuth('AllocateDeposit')">Allocate Deposits</option>
                          <option :value="3" v-if="$root.checkAuth('RequestWaiver')">Waiver</option>
                          <option :value="4" v-if="$root.checkAuth('ReceiveInsuranceInvoice')">Insurance Invoice</option>
                          
                        </select>
                      </template>
                     </tail-select>
                    <div class="w-full flex">  <div v-if="active == 5" class="md:w-1/3 sm:w-full p-tiny">
            <label for="grid-memo" class="label-control">Phone Number:</label>
            <input type="text" v-model.trim="mppay.phonenumber" 
                        v-on:keyup.enter="initiatempesastk(mppay.phonenumber,totalReceive,patient.patientname)" 
                        id="grid-search" class="input-sm input-control text-xs">
                        <p class="form-text-error" 
                                        v-if="mpesaErrors.filter(error => error.field == 'phonenumber').length">
                                        {{ 
                                            mpesaErrors.filter(error => error.field == 'phonenumber')[0].message
                                        }}</p>
            <!-- <input type="text" v-model.trim="filter" id="grid-memo" class="input-control input-sm text-xs"> -->
        </div>
        <div v-if="active == 5" class="md:w-1/3 sm:w-1/3 p-tiny mt-3">
          <label for="grid-memo" class="label-control"></label>  
                <button class="btn-sm bg-orange-600 text-white font-bold whitespace-no-wrap 
                                    rounded text-xs" @click.prevent="initiatempesastk(mppay.phonenumber,totalReceive,patient.patientname)"><i class="fa fa-hand-holding-usd"></i> Initiate Payment</button>
                                    <input type="text" v-if="0" v-model.trim="mppay.amount" 
                         id="grid-search" class="input-sm input-control text-xs">
                        <p class="form-text-error" 
                                        v-if="mpesaErrors.filter(error => error.field == 'amount').length">
                                        {{ 
                                            mpesaErrors.filter(error => error.field == 'amount')[0].message
                                        }}</p>   </div> 
                                        <div v-if="active == 5 && stkinitiated==1 " class="md:w-1/3 sm:w-1/3 p-tiny mt-3">
                               <span class="text-red-700">{{stkresponsemessage}}</span> </div>
                          
                            </div>
                            <div class="w-full flex">  <div v-if="active == 5" class="md:w-2/3 sm:w-full p-tiny">
            <label for="grid-memo" class="label-control">Filter/Refresh:</label>
            <input type="text" v-model.trim="mpesafilter" 
                        v-on:keyup.enter="filtermpesapayments" 
                        id="grid-search" class="input-sm input-control text-xs">

            <!-- <input type="text" v-model.trim="filter" id="grid-memo" class="input-control input-sm text-xs"> -->
        </div>
        <div v-if="active == 5" class="md:w-1/3 sm:w-1/3 p-tiny mt-3">
          <label for="grid-memo" class="label-control"></label>           <button class="btn-sm btn-primary text-xs" @click.prevent="filtermpesapayments"><i class="fa fa-search"></i> Filter/Refresh</button>
                            </div>
                          </div>
                  </div>
                  <div class="w-full" v-if="active === 0">
                    <cash-sale-form
                      :cashCOAs="cashCOAs"
                      :cashPModes="cashPModes"
                      :totalBalance="totalReceive"
                      :cashSale="cashSale"
                      :errors="cashErrors"
                    />
                  </div>
                  <div class="w-full" v-if="active === 1">
                    <bank-deposit-form
                      :totalBalance="totalReceive"
                      :bankPayment="bankPayment"
                      :errors="bankErrors"
                      :bankCOAs="bankCOAs"
                      :bankPModes="bankPModes"
                    />
                  </div>
                  <div class="w-full" v-if="active === 2">
                    <allocate-deposit-form
                      :totalReceive="totalReceive"
                      :depositAllocation="depositAllocation"
                      :deposits="deposits"
                    />
                  </div>
                  <div class="w-full" v-if="active === 3">
                    <waiver-form
                      :totalBalance="totalReceive"
                      :initiateWeiver="initiateWeiver"
                      :errors="weiverErrors"
                    />
                  </div>
                  <div class="w-full" v-if="active === 4">
                    <insurance-invoice-form
                      :benefitPackages="benefitPackages"
                      :insuranceSchemes="insuranceSchemes"
                      :insuranceInvoice="insuranceInvoice"
                      :insurances="insurances"
                      :totalReceive="totalReceive"
                    />
                  </div> 
                  <div class="w-full" v-if="active === 5">
                    <allocate-mpesa-form
                      :totalReceive="totalReceive"
                      :mpesaAllocation="mpesaAllocation"
                      :mpesapayments="mpesapayments"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:card-footer>
          <div class="w-full text-right" v-if="activeTab === 0">
            <router-link
              :to="{ name: `billing.patients.index` }"
              class="btn-sm btn-danger text-xs rounded mr-8"
            >
              <i class="fa fa-caret-left"></i> Back</router-link
            >
            <button
              v-if="active == 0"
              class="btn-sm bg-blue-500 text-xs text-white rounded whitespace-no-wrap"
              @click.prevent="saveCashSale"
            >
              <i class="fa fa-save"></i> Cash Sale
            </button>
            <button
              v-if="active == 1"
              class="btn-sm bg-blue-500 text-xs text-white rounded whitespace-no-wrap"
              @click.prevent="saveBankPayment"
            >
              <i class="fa fa-save"></i> Bank Receipt
            </button>
            <button
              v-if="active == 2"
              class="btn-sm bg-blue-500 text-xs text-white rounded whitespace-no-wrap"
              @click.prevent="saveDepositAllocation"
            >
              <i class="fa fa-save"></i> Allocate Deposit
            </button>
            <button
              v-if="active == 3"
              class="btn-sm bg-blue-500 text-xs text-white rounded whitespace-no-wrap"
              @click.prevent="saveWeiver"
            >
              <i class="fa fa-save"></i> Initiate Waiver
            </button>
            <button
              v-if="active == 4"
              class="btn-sm bg-blue-500 text-xs text-white rounded whitespace-no-wrap"
              @click.prevent="saveInsuranceInvoice"
            >
              <i class="fa fa-save"></i> Insurance Invoice
            </button> 
            <button
              v-if="active == 5"
              class="btn-sm bg-blue-500 text-xs text-white rounded whitespace-no-wrap"
              @click.prevent="saveMpesaAllocation"
            >
              <i class="fa fa-save"></i> Allocate Mpesa
            </button>
          </div>
          <confirm-cash-sale
            :totalBalance="totalBalance"
            :patient="patient"
            :cashSale="cashSale"
            :billItems="checkedBillItems"
            :showModal="showConfirmCashSale"
            @refresh="
              () => {
                fetchPendingPostedBills();
                resetCashSale();
              }
            "
            @closeModal="showConfirmCashSale = false"
            @print="printReceipt"
          ></confirm-cash-sale>
          <confirm-bank-payment
            :showModal="showConfirmBankPayment"
            :bankPayment="bankPayment"
            :billItems="checkedBillItems"
            :totalBalance="totalBalance"
            :patient="patient"
            @closeModal="showConfirmBankPayment = false"
            @refresh="
              () => {
                fetchPendingPostedBills();
                resetbankPayment();
              }
            "
            @print="printReceipt"
          ></confirm-bank-payment>
          <confirm-deposit-allocation
            :totalBalance="totalBalance"
            :patient="patient"
            :cashSale="cashSale"
            :billItems="checkedBillItems"
            :showModal="showConfirmDepAllocation"
            :depositAllocation="depositAllocation"
            :allocatedDeposits="allocatedDeposits"
            :totalDepositAmount="totalDepositAmount"
            @closeModal="showConfirmDepAllocation = false"
            @print="printReceipt"
            @refresh="
              () => {
                fetchPendingPostedBills();
                fetchDeposits();
              }
            "
          ></confirm-deposit-allocation>
           <confirm-mpesa-allocation
            :totalBalance="totalBalance"
            :patient="patient"
            :cashSale="cashSale"
            :billItems="checkedBillItems"
            :showModal="showConfirmMpesaAllocation"
            :mpesaAllocation="mpesaAllocation"
            :allocatedmpesaPayments="allocatedmpesaPayments"
            :totalmpesaAmount="totalmpesaAmount"
            @closeModal="showConfirmMpesaAllocation = false"
            @print="printReceipt"
            @refresh="
              () => {
                fetchPendingPostedBills();
                filtermpesapayments();
              }
            "
          ></confirm-mpesa-allocation>
          
          <confirm-insurance-invoice
            :totalBalance="totalBalance"
            :patient="patient"
            :insuranceInvoice="insuranceInvoice"
            :showModal="showConfirmInsuranceInvoice"
            :billItems="checkedBillItems"
            :insuranceDetails="insuranceDetails"
            :totalInsuranceAmount="totalReceive"
            @closeModal="showConfirmInsuranceInvoice = false"
            @refresh="
              () => {
                fetchPendingPostedBills();
                fetchInsurances();
              }
            "
            @print="printInsuranceInvoice"
          ></confirm-insurance-invoice>
          <confirm-initiate-weiver
            :totalBalance="totalBalance"
            :patient="patient"
            :billItems="checkedBillItems"
            :initiateWeiver="initiateWeiver"
            :showModal="showConfirmInitiateWeiver"
            @closeModal="showConfirmInitiateWeiver = false"
            @refresh="
              () => {
                fetchPendingPostedBills();
                resetInitiateWeiver();
              }
            "
          ></confirm-initiate-weiver>
        </template>
      </tail-card>
    </template>
  </tail-base-layout>
</template>
